import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    CardHeader,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    UncontrolledPopover,
    PopoverHeader,
    PopoverBody,
    Toast,
    ToastHeader,
    ToastBody,
} from "reactstrap";
import { useAuth } from "../../Provider/AuthProvider";
import { SearchResult } from "./Interfaces";
import LoadingOverlay from "./LoadingOverlay";

const Caisse = () => {
    const { user, order, changeOrder } = useAuth();
    const orderRef = useRef(order);
    useEffect(() => { orderRef.current = order; }, [order]);

    const calculateTotals = () => {
        if (!order?.lines) return { totalHT: 0, totalTVA: 0 };
        const totalHT = order.lines.reduce(
            (sum, line) => sum + parseFloat(line.total_ht || "0"),
            0
        );
        const totalTVA = order.lines.reduce(
            (sum, line) => sum + parseFloat(line.total_tva || "0"),
            0
        );
        return { totalHT, totalTVA };
    };

    const [montant, setMontant] = useState("");
    const [clientId, setClientId] = useState("");
    const [orderDetailsModalOpen, setOrderDetailsModalOpen] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState("Espèce");
    const [modalOpen, setModalOpen] = useState(false);
    const [pdfModalOpen, setPdfModalOpen] = useState(false);
    const [resteAPayer, setResteAPayer] = useState(order?.resteapayer || 0);
    const [discountsModalOpen, setDiscountsModalOpen] = useState(false);
    const [selectedDiscounts, setSelectedDiscounts] = useState<number[]>([]);
    const [isApplyingDiscounts, setIsApplyingDiscounts] = useState(false);
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    const [isFetchingDiscounts, setIsFetchingDiscounts] = useState(false);

    const formatMontantDisplay = (amount: string) => {
        if (!amount) return "0.00";

        if (amount.includes('.') && amount.split('.')[1].length === 2) {
            return amount;
        }

        const num = parseFloat(amount);
        if (isNaN(num)) return "0.00";

        return num.toFixed(2);
    };

    const [showToast, setShowToast] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState({
        transactionId: "",
        bank: "",
    });
    const [orders, setOrders] = useState<SearchResult[]>([]);
    const [id, setId] = useState(0);

    const toggleOrderDetailsModal = () => {
        setOrderDetailsModalOpen(prev => !prev);
    };

    const togglePdfModal = () => {
        setPdfModalOpen(!pdfModalOpen);
      
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedPayment("Espèce");
        setPaymentDetails({ transactionId: "", bank: "" });
    };

    const isSearchInputFocused = () => {
        const searchInput = document.getElementById("search-options") as HTMLInputElement;
        return document.activeElement === searchInput;
    };


    const [discounts, setDiscounts] = useState<any[]>([]);
    const [totalCreditNote, setTotalCreditNote] = useState<number>(0);


    const fetchDiscountsForClient = async (clientId: number) => {
        
        try {
            const response: any = await axios.post(
                "/apiV2/",
                {
                    action: "getDiscounts",
                    socid: clientId,
                    entity: user.entity
                },
                {
                    baseURL: "https://api.apapiecesauto.fr",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`,
                    },
                }
            );
            
            if (response.success) {
                setDiscounts(response.discounts || []);
                setTotalCreditNote(parseFloat(response.amounts.absolute_creditnote) || 0);
                setSelectedDiscounts([]);
            } else {
                setDiscounts([]);
                setTotalCreditNote(0);
                setSelectedDiscounts([]);
            }
        } catch (error) {
            console.error("Error fetching discounts:", error);
            setDiscounts([]);
            setTotalCreditNote(0);
            setSelectedDiscounts([]);
        }
    };

    const handleApplyDiscounts = async () => {
        if (!order || selectedDiscounts.length === 0) return;

        setIsApplyingDiscounts(true);
        

        const data = {
            action: "setDiscounts",
            order_id: order.id,
            discounts: selectedDiscounts,
            restapayer: order.resteapayer,
            entity: user.entity
        }
        try {
            
            const response : any = await axios.post(
                "/apiV2/",
                data,
                {
                    baseURL: "https://api.apapiecesauto.fr",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`,
                    },
                }
            );
            if (response.success) {
                
                var newOrder = order;
                newOrder.resteapayer = response.restapayer;
                newOrder.paiements = response.paiements;
                if (response.object) {
                    ;
                    newOrder.invoicepdf = response.object.invoicepdf;
                }
                changeOrder(newOrder);
                setMontant(response.resteapayer);

                setDiscountsModalOpen(false);
                // Reset selected discounts
                //setSelectedDiscounts([]);

                // Show success message
                setShowToast(true);
                setTimeout(() => setShowToast(false), 3000);
            } else {
                console.error("Failed to apply discounts:", response.data);
                alert("Erreur lors de l'application des avoirs");
            }
        } catch (error) {
            console.error("Error applying discounts:", error);
            alert("Erreur lors de l'application des avoirs");
        } finally {
            setIsApplyingDiscounts(false);
        }
    };


    const handleDiscountCheckboxChange = (discountId: number) => {
        setSelectedDiscounts(prev => {
            if (prev.includes(discountId)) {
                return prev.filter(id => id !== discountId);
            } else {
                return [...prev, discountId];
            }
        });
    };

   
    useEffect(() => {
        
        if (order) {
            fetchDiscountsForClient(order.client_id);
        } 
    }, [order]);


    const fetchCommandes = async () => {

        try {
            const response = await axios.post(
                "/apiV2/",
                { action: "topay", entity: user.entity },
                {
                    baseURL: "https://api.apapiecesauto.fr",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`,
                    },
                }
            );

            const listCommandes: SearchResult[] = response.data || [];
            console.log(response.data,"response.data")
            const existingIds = new Set(orders.map((f) => f.id));
            const ids = new Set(listCommandes.map((f) => f.id));
            const uniqueNewFactures = listCommandes.filter((c) => !existingIds.has(c.id));
            const updatedFactures = [...orders.filter((f) => ids.has(f.id)), ...uniqueNewFactures];

            setOrders(updatedFactures);
            if (!orderRef.current && !isSearchInputFocused() && updatedFactures.length > 0) {
                const newestFacture = updatedFactures[0];
                changeOrder(newestFacture);
                setId(parseInt(newestFacture.id));
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };


    useEffect(() => {
        fetchCommandes();
        const intervalId = setInterval(fetchCommandes, 10000);
        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        if (!order && orders.length > 0 && !isSearchInputFocused()) {
            const newestFacture = orders[0];
            changeOrder(newestFacture);
            setId(parseInt(newestFacture.id));
        }
    }, [orders, montant]);

    const isMontantValid = () => {
        if (!order) return false;

        const amount = parseFloat(montant);
        return !isNaN(amount) && amount > 0 && amount <= order.resteapayer;
    };

    const isPaymentEnabled = isMontantValid();
    const errorMessage =
        !isMontantValid() && montant !== ""
            ? "Le montant doit être entre 0 et le reste à payer."
            : "";

    const handleBackspace = () => {
        setMontant((prev) => prev.slice(0, -1));
        setSelectedPayment("Espèce");
        setPaymentDetails({ transactionId: "", bank: "" });
        setModalOpen(false);
    };

    const handleClearAll = () => {
        setMontant("");
        setSelectedPayment("Espèce");
        setPaymentDetails({ transactionId: "", bank: "" });
        setModalOpen(false);
    };
    const calculateSelectedDiscountTotal = () => {
        return discounts
            .filter(discount => selectedDiscounts.includes(discount.rowid))
            .reduce((total, discount) => total + parseFloat(discount.amount_ttc || "0"), 0);
    };
    const handleNumberClick = (value: string) => {
        setMontant((prev) => {
            if (value === "." && prev.includes(".")) return prev;
            if (value === "." && prev === "") return "0.";
            if (prev === "0" && value !== ".") return value;
            const [integerPart, decimalPart] = prev.split(".");
            if (decimalPart && decimalPart.length >= 2 && value !== "") return prev;
            return prev + value;
        });
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;

        if (value === "" || /^\d*\.?\d*$/.test(value)) {
            if (value.startsWith("0") && value.length > 1 && !value.startsWith("0.")) {
                value = value.replace(/^0+/, "");
                if (value === "") value = "0";
            }
            setMontant(value);

            if (value === "") {
                setSelectedPayment("");
                setPaymentDetails({ transactionId: "", bank: "" });
                setModalOpen(false);
            }
        }
    };

    const getPaymentCode = (method: string) => {
        switch (method) {
            case "Espèce":
                return "LIQ";
            case "Carte Bancaire":
                return "CB";
            case "Cheque":
                return "CHQ";
            case "Virement":
                return "VIR";
            default:
                return "";
        }
    };

    const popupStyle: React.CSSProperties = {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1050,
        backgroundColor: 'white',
        width: '80%',
        maxWidth: '800px',
        maxHeight: '80vh',
        overflowY: 'auto' as const,  // Use 'as const' for literal types
        padding: '20px',
        borderRadius: '5px',
        boxShadow: '0 5px 15px rgba(0,0,0,0.5)',
        display: 'none'
    };

    const popupBackdrop: React.CSSProperties = {
        position: 'fixed' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1040,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'none'
    };

    const handlePaymentSelection = (method: string) => {
        setSelectedPayment(method);
        if (method === "Cheque" || method === "Carte Bancaire" || method === "Virement") {
            setModalOpen(true);
        } else {
            setPaymentDetails({ transactionId: "", bank: "" });
        }
    };

    const handlePaymentDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setPaymentDetails((prev) => ({ ...prev, [name]: value }));
    };

    const handleFactureSelect = (selectedOrder: SearchResult) => {
        changeOrder(selectedOrder);
        setId(parseInt(selectedOrder.id));
    };
    const calculateTotalCreditMontant = () => {
        if (!discounts || discounts.length === 0) return 0;
        // Sum up all discount amounts (using total_ttc)
        const total = discounts.reduce((sum, discount) => {
            const amount = parseFloat(discount.amount_ttc || "0");
            return sum + amount;
        }, 0);

        return total;
    };

    const handlePayment = async () => {
        if (!order || !isPaymentEnabled) return;
        setIsProcessingPayment(true);
        
        const payload = {
            action: 'paiement',
            ref: order.ref,
            entity: user.entity,
            code: getPaymentCode(selectedPayment),
            amount: parseFloat(montant).toFixed(2),
            ...(selectedPayment === 'Cheque'
                ? {
                    bank: paymentDetails.bank,
                    transaction_id: paymentDetails.transactionId,
                }
                : (selectedPayment === 'Carte Bancaire' || selectedPayment === 'Virement')
                    ? {
                        transaction_id: paymentDetails.transactionId,
                    }
                    : {}),
        };
        
        try {
            axios.post(
                "/apiV2/",
                payload,
                {
                    baseURL: "https://api.apapiecesauto.fr",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`,
                    },

                }
            ).then(async (data: any) => {
                debugger;
                const updatedInvoice: SearchResult = data.object;
                if (updatedInvoice) {
                    
                    var newOrder = order;
                    newOrder.resteapayer = updatedInvoice.resteapayer;
                    newOrder.paiements = updatedInvoice.paiements;
                    newOrder.invoicepdf = updatedInvoice.invoicepdf;
                    changeOrder(newOrder);
                    setMontant((updatedInvoice.resteapayer || 0).toString());
            //    setId(parseInt(updatedInvoice.id));
                }
                setIsProcessingPayment(false);

            setShowToast(true);
            setTimeout(() => setShowToast(false), 3000);
                
            const commandesResponse = await axios.post(
                "/apiV2/",
                { action: "topay", entity: user.entity },
                {
                    baseURL: "https://api.apapiecesauto.fr",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${user.token}`,
                    },
                }
            );
                const newCommandes: SearchResult[] = commandesResponse.data || [];
            setOrders((prev) => {
                const existingIds = new Set(prev.map((f) => f.id));
                const uniqueNewFactures = newCommandes.filter((f) => !existingIds.has(f.id));
                const updatedFactures = [...prev, ...uniqueNewFactures];
                if (orderRef.current === null && !isSearchInputFocused() && updatedFactures.length > 0) {
                    const newestFacture = updatedFactures[0];
                    changeOrder(newestFacture);
                    setId(parseInt(newestFacture.id));
                }
                return updatedFactures;
            });
            });

        } catch (error) {
            
            console.error('Erreur lors du paiement:', error);
        }

        setModalOpen(false);
        setMontant('');
        setSelectedPayment("Espèce");
        setPaymentDetails({ transactionId: '', bank: '' });
    };

    useEffect(() => {
        if (order) {
            setMontant(order.resteapayer.toFixed(2));
            setResteAPayer(order.resteapayer);
        } else {
            setMontant("");
            setResteAPayer(0);
        }
        setPaymentDetails({ transactionId: "", bank: "" });
    }, [order]);

    useEffect(() => {
        if (!isMontantValid()) {
            setSelectedPayment("Espèce");
            setPaymentDetails({ transactionId: "", bank: "" });
            setModalOpen(false);
        }
    }, [montant]);




    return (
        <React.Fragment>
            <LoadingOverlay
                isVisible={isProcessingPayment || isApplyingDiscounts || isFetchingDiscounts}
            />

            <div className="page-content pb-0">
                <Container fluid>
                    <Row>
                        <Col xl="8">
                            {order ? (
                                <Card
                                    className="mb-4 border border-2 border-primary"
                                    style={{ minHeight: 150, maxHeight: 150, height: 150 }}
                                >
                                    <CardHeader className="bg-primary bg-opacity-10 border-bottom border-primary border-opacity-25">
                                        <Row>
                                            <Col md={4}>
                                                <div className="d-flex align-items-center">
                                                    <i className="ri-shopping-bag-line align-middle me-2 fs-3"></i>
                                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                                        <button
                                                            type="button"
                                                            style={{
                                                                border: 'none',
                                                                background: 'none',
                                                                padding: 0,
                                                                cursor: 'zoom-in',
                                                                textDecoration: 'none',
                                                                color: 'inherit',
                                                                fontWeight: 'inherit'
                                                            }}
                                                            onMouseEnter={() => setOrderDetailsModalOpen(true)}
                                                            onMouseLeave={() => setOrderDetailsModalOpen(false)}
                                                            onClick={() => setOrderDetailsModalOpen(!orderDetailsModalOpen)}
                                                        >
                                                            {order.ref}
                                                        </button>
                                                    </div>
                                                    {/* Add this discount button */}

                                                    {discounts.length > 0 && (
                                                        <Button
                                                            color="primary"
                                                            size="sm"
                                                            className="ms-2"
                                                            onClick={() => {
                                                                if (order) {
                                                                    fetchDiscountsForClient(order.client_id);
                                                                    setDiscountsModalOpen(true);
                                                                }
                                                            }}
                                                            title="Voir les avoirs"
                                                        >
                                                            <i className="ri-coupon-line me-1"></i> Avoir
                                                        </Button>
                                                        )}
                                                </div>
                                            </Col>
                                            <Col md={4} className="text-end">

                                             
                                                {(order?.invoicepdf || order?.resultPDF) && (
                                                    <Button
                                                        color="link"
                                                        size="m"
                                                        className="p-0 text-primary"
                                                        style={{ float: "right" }}
                                                        title={order?.invoicepdf ? "Voir la facture" : "Voir la commande"}
                                                        onClick={togglePdfModal}
                                                    >
                                                        <i className="ri-file-pdf-line fs-4 me-1"></i>
                                                        {order?.invoicepdf ? "Voir la facture" : "Voir la commande"}
                                                    </Button>
                                                )}
                                            </Col>

                                            <Col md={4} className="text-end">
                                                <span className="text-danger fw-semibold">
                                                    Reste à payer: {order?.resteapayer?.toFixed(2)} €
                                                    {order?.paiements?.paiements?.length > 0 && (
                                                        <>
                                                            <i
                                                                className="ri-information-line ms-2 text-primary fs-4"
                                                                id={`restePopover-${order.id}`}
                                                                style={{ cursor: "pointer" }}
                                                            />
                                                            <UncontrolledPopover
                                                                placement="bottom"
                                                                target={`restePopover-${order.id}`}
                                                                trigger="hover"
                                                            >
                                                                <PopoverHeader>Historique des paiements</PopoverHeader>
                                                                <PopoverBody>
                                                                    <table className="table table-sm table-bordered mb-0">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Date</th>
                                                                                <th>Montant</th>
                                                                                <th>Méthode</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {order?.paiements?.paiements?.map(
                                                                                (payment, index) => (
                                                                                    <tr key={index}>
                                                                                        <td>
                                                                                            {payment?.date
                                                                                                ? new Date(payment.date).toISOString().split("T")[0]
                                                                                                : "-"}
                                                                                        </td>
                                                                                        <td>{Number(payment?.amount || 0).toFixed(2)} €</td>
                                                                                        <td>{convertPaymentType(payment?.type_paiement)}</td>
                                                                                    </tr>
                                                                                )
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </PopoverBody>
                                                            </UncontrolledPopover>
                                                        </>
                                                    )}
                                                </span>
                                            </Col>
                                        </Row>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col md={6}>
                                                <div>
                                                    <Label className="form-label text-muted small mb-1">
                                                        Client
                                                    </Label>
                                                    <p className="fw-medium mb-0">{order.client}</p>

                                                    <p className="fw-medium mb-0"></p>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div>
                                                    <Label className="form-label text-muted small mb-1">
                                                        Date
                                                    </Label>
                                                    <p className="text-muted mb-0">{order.date}</p>
                                                </div>
                                            </Col>
                                            <Col md={3}>
                                                <div>
                                                    <Label className="form-label text-muted small mb-1">
                                                        Total TTC
                                                    </Label>
                                                    <p className="fw-semibold mb-0 fs-5 text-success">
                                                        {Number(order?.total_ttc).toFixed(2)} €
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            ) : (
                                <Card
                                    className="mb-3 border border-2 border-primary"
                                    style={{ minHeight: 150, maxHeight: 150, height: 150 }}
                                >
                                    <CardBody className="text-center py-5">
                                        <h5 className="text-muted">Aucune commande sélectionnée</h5>
                                        <p className="text-muted mb-0">
                                            Veuillez sélectionner une facture pour continuer.
                                        </p>
                                    </CardBody>
                                </Card>
                            )}
                            <Row className="g-3">
                                <Col xl={6}>
                                    <Card className="shadow-sm h-90 mb-0">
                                        <CardBody>
                                            <div className="mb-2">
                                                <div className="position-relative">
                                                    <Input
                                                        type="text"
                                                        className="form-control mb-2 pe-4"
                                                        placeholder="Entrez un montant"
                                                        value={montant}
                                                        onChange={handleInputChange}
                                                        disabled={!order || order?.resteapayer === 0}
                                                    />
                                                    {montant && (
                                                        <button
                                                            type="button"
                                                            style={{
                                                                position: 'absolute',
                                                                right: '10px',
                                                                top: '8px',
                                                                border: 'none',
                                                                background: 'none',
                                                                padding: 0,
                                                                cursor: 'pointer',
                                                                color: '#6c757d',
                                                            }}
                                                            onClick={handleClearAll}
                                                        >
                                                            <i className="ri-close-circle-line text-danger"></i>
                                                    </button>
                                                    )}
                                                </div>                                              
                                            </div>
                                            <div className="pavenum">
                                                <Row className="g-2">
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("1")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            1
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("2")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            2
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("3")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            3
                                                        </button>
                                                    </Col>
                                                </Row>
                                                <Row className="g-2 mt-2">
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("4")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            4
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("5")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            5
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("6")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            6
                                                        </button>
                                                    </Col>
                                                </Row>
                                                <Row className="g-2 mt-2">
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("7")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            7
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("8")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            8
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("9")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            9
                                                        </button>
                                                    </Col>
                                                </Row>
                                                <Row className="g-2 mt-2">
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={handleBackspace}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            <i className="ri-arrow-go-back-line"></i>
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick("0")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            0
                                                        </button>
                                                    </Col>
                                                    <Col xs={4}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-md w-100 fs-5"
                                                            style={{ minHeight: "40px" }}
                                                            onClick={() => handleNumberClick(".")}
                                                            disabled={!order || order?.resteapayer === 0}
                                                        >
                                                            .
                                                        </button>
                                                    </Col>
                                                </Row>
                                                {order?.resteapayer !== 0 && errorMessage && (
                                                    <p className="text-danger small mt-3 mb-0" style={{ fontSize: "13px" }}>{errorMessage}</p>
                                                )}
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col xl={6}>
                                    <Card className="shadow-sm h-90 mb-0">
                                        <CardBody className="p-3">
                                            <div className="mb-1 text-center border-bottom pb-1">
                                                <h5 className="mb-0">
                                                    <span className="text-success">{formatMontantDisplay(montant)} </span>
                                                </h5>
                                            </div>
                                            <Row className="g-1">
                                                <Col lg={12} sm={12}>
                                                    <div className="form-check card-radio">
                                                        <Input
                                                            id="paymentMethod01"
                                                            name="paymentMethod"
                                                            type="radio"
                                                            className="form-check-input"
                                                            disabled={!isPaymentEnabled}
                                                            onChange={() => handlePaymentSelection("Cheque")}
                                                            checked={selectedPayment === "Cheque"}
                                                        />
                                                        <Label
                                                            className="form-check-label w-100 p-2"
                                                            htmlFor="paymentMethod01"
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span className="fs-3 text-muted me-2">
                                                                    <i className="ri-bank-card-line"></i>
                                                                </span>
                                                                <div>
                                                                    <span className="fs-14 d-block text-wrap">
                                                                        Chèque
                                                                    </span>
                                                                    <small className="text-muted">
                                                                        Paiement par chèque
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </Label>
                                                    </div>
                                                </Col>
                                                <Col lg={12} sm={12}>
                                                    <div className="form-check card-radio">
                                                        <Input
                                                            id="paymentMethod02"
                                                            name="paymentMethod"
                                                            type="radio"
                                                            className="form-check-input"
                                                            disabled={!isPaymentEnabled}
                                                            onChange={() => handlePaymentSelection("Carte Bancaire")}
                                                            checked={selectedPayment === "Carte Bancaire"}
                                                        />
                                                        <Label
                                                            className="form-check-label w-100 p-2"
                                                            htmlFor="paymentMethod02"
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span className="fs-3 text-muted me-2">
                                                                    <i className="ri-bank-card-fill"></i>
                                                                </span>
                                                                <div>
                                                                    <span className="fs-14 d-block text-wrap">
                                                                        Carte Bancaire
                                                                    </span>
                                                                    <small className="text-muted">
                                                                        Visa/Mastercard
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </Label>
                                                    </div>
                                                </Col>
                                                <Col lg={12} sm={12}>
                                                    <div className="form-check card-radio">
                                                        <Input
                                                            id="paymentMethod03"
                                                            name="paymentMethod"
                                                            type="radio"
                                                            className="form-check-input"
                                                            disabled={!isPaymentEnabled}
                                                            onChange={() => handlePaymentSelection("Espèce")}
                                                            checked={selectedPayment === "Espèce"}
                                                        />
                                                        <Label
                                                            className="form-check-label w-100 p-2"
                                                            htmlFor="paymentMethod03"
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span className="fs-3 text-muted me-2">
                                                                    <i className="ri-money-dollar-box-fill"></i>
                                                                </span>
                                                                <div>
                                                                    <span className="fs-14 d-block text-wrap">
                                                                        Espèces
                                                                    </span>
                                                                    <small className="text-muted">
                                                                        Paiement en espèces
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </Label>
                                                    </div>
                                                </Col>
                                                <Col lg={12} sm={12}>
                                                    <div className="form-check card-radio">
                                                        <Input
                                                            id="paymentMethod04"
                                                            name="paymentMethod"
                                                            type="radio"
                                                            className="form-check-input"
                                                            disabled={!isPaymentEnabled}
                                                            onChange={() => handlePaymentSelection("Virement")}
                                                            checked={selectedPayment === "Virement"}
                                                        />
                                                        <Label
                                                            className="form-check-label w-100 p-1"
                                                            htmlFor="paymentMethod04"
                                                        >
                                                            <div className="d-flex align-items-center">
                                                                <span className="fs-3 text-muted me-2">
                                                                    <i className="ri-bank-line"></i>
                                                                </span>
                                                                <div>
                                                                    <span className="fs-14 d-block text-wrap">
                                                                        Virement
                                                                    </span>
                                                                    <small className="text-muted">
                                                                        Paiement par virement bancaire
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </Label>
                                                    </div>
                                                </Col>
                                            </Row>
                                            {selectedPayment === "Espèce" && isMontantValid() && (
                                                <div className="mt-2">
                                                    <Button
                                                        color="success"
                                                        className="w-100"
                                                        onClick={handlePayment}
                                                        disabled={!isPaymentEnabled}
                                                    >
                                                        Encaissé
                                                    </Button>
                                                </div>
                                            )}
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                        <Col xl="4">
                            <div className="position-sticky" style={{ top: "80px" }}>
                                <Card className="shadow-sm border border-2 border-primary" style={{ margin: 0, background: "none" }}>
                                    <CardBody style={{ maxHeight: "calc(100vh - 190px)", height: "calc(100vh - 190px)", overflowY: "auto", padding: 8 }}>
                                        {orders.length > 0 ? (
                                            <ul className="list-group">
                                                {orders.map((facture) => (
                                                    <li
                                                        key={facture.id}
                                                        className={`list-group-item fs-14 ${order?.id === facture.id ? 'active-order' : ''}`}
                                                        onClick={() => handleFactureSelect(facture)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            padding: '0.75rem 1.25rem',
                                                            marginBottom: 5,
                                                            backgroundColor: order?.id === facture.id ? 'aliceblue' : '#fff',
                                                            border: '1px solid #dee2e6',
                                                            borderRadius: '4px'
                                                        }}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span>{facture.ref}</span>
                                                            <span className="text-muted">{Number(facture.total_ttc).toFixed(2)} €</span>
                                                        </div>
                                                        <small className="text-muted">{facture.client}</small>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-muted">Aucune facture disponible.</p>
                                        )}
                                    </CardBody>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </Container>

                <Modal isOpen={discountsModalOpen} toggle={() => setDiscountsModalOpen(false)} size="lg">
                    <ModalHeader toggle={() => {
                        setDiscountsModalOpen(false);
                        setSelectedDiscounts([]);
                    }}>
                        <div className="d-flex align-items-center">
                            <i className="ri-coupon-line me-2 fs-4 text-warning"></i>
                            <span>Avoirs disponibles</span>
                            {selectedDiscounts.length > 0 && (
                                <span className="badge bg-primary ms-2">
                                    {selectedDiscounts.length} sélectionné{selectedDiscounts.length > 1 ? 's' : ''}
                                </span>
                            )}
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        {discounts.length > 0 ? (
                            <>
                                {/* Display original reste à payer */}
                                {order && (
                                    <div className="alert alert-info border-0 shadow-sm mb-3">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center">
                                                <i className="ri-information-line fs-4 me-2"></i>
                                                <div>
                                                    <strong className="d-block">Reste à payer</strong>
                                                    <small className="text-muted">Montant total à régler</small>
                                                </div>
                                            </div>
                                            <div>
                                                <span className="fs-3 fw-bold text-dark">{order.resteapayer.toFixed(2)} €</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="table-responsive mb-3">
                                    <table className="table table-hover table-borderless mb-0">
                                        <thead className="table-light border">
                                            <tr>
                                                <th style={{ width: '50%' }}>Référence</th>
                                                <th className="text-end" style={{ width: '25%' }}>Montant TTC</th>
                                                <th className="text-center" style={{ width: '25%' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {discounts.map((discount, index) => (
                                                <tr
                                                    key={index}
                                                    className={discount.used || discount.used === 1 ? 'table-warning' : ''}
                                                >
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span className="fw-semibold">{discount.ref}</span>
                                                            {discount.date && (
                                                                <small className="text-muted">
                                                                    <i className="ri-calendar-line me-1"></i>
                                                                    {new Date(discount.date).toLocaleDateString()}
                                                                </small>
                                                            )}
                                                            {discount.used || discount.used === 1 ? (
                                                                <span className="badge bg-warning mt-1" style={{ width: 'fit-content' }}>
                                                                    <i className="ri-checkbox-circle-line me-1"></i>
                                                                    Déjà utilisé
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    </td>
                                                    <td className="text-end align-middle">
                                                        <span className="fw-bold fs-5 text-success">
                                                            {Number(discount.amount_ttc).toFixed(2)} €
                                                        </span>
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {!(discount.used || discount.used === 1) ? (
                                                                <>
                                                                    <FormGroup check className="mb-0">
                                                                        <Input
                                                                            type="checkbox"
                                                                            id={`discount-${discount.rowid || index}`}
                                                                            className="form-check-input-lg"
                                                                            style={{
                                                                                width: '22px',
                                                                                height: '22px',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            checked={selectedDiscounts.includes(discount.rowid)}
                                                                            onChange={() => handleDiscountCheckboxChange(discount.rowid)}
                                                                        />
                                                                        <Label
                                                                            htmlFor={`discount-${discount.rowid || index}`}
                                                                            className="form-check-label ms-2"
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            Sélectionner
                                                                        </Label>
                                                                    </FormGroup>
                                                                </>
                                                            ) : (
                                                                <span className="text-muted">
                                                                    <i className="ri-lock-line fs-4"></i>
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Summary Cards */}
                                <div className="row g-3 mb-3">
                                    <div className="col-md-6">
                                        <div className="card border-primary border-1 shadow-sm">
                                            <div className="card-body py-3">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <h6 className="text-muted mb-1">Crédit disponible</h6>
                                                        <h4 className="text-primary mb-0">
                                                            {calculateTotalCreditMontant().toFixed(2)} €
                                                        </h4>                                                    </div>
                                                    <i className="ri-wallet-3-line fs-1 text-primary"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {selectedDiscounts.length > 0 && (
                                        <div className="col-md-6">
                                            <div className="card border-success border-1 shadow-sm">
                                                <div className="card-body py-3">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <h6 className="text-muted mb-1">Montant sélectionné</h6>
                                                            <h4 className="text-success mb-0">{calculateSelectedDiscountTotal().toFixed(2)} €</h4>
                                                        </div>
                                                        <i className="ri-checkbox-circle-line fs-1 text-success"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {selectedDiscounts.length > 0 && order && (
                                    <div className="card border-warning border-2 shadow mb-3">
                                        <div className="card-body py-2">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="d-flex align-items-center">
                                                    <i className="ri-arrow-right-s-line fs-3 text-warning me-2"></i>
                                                    <div>
                                                        <h6 className="text-muted mb-0">Nouveau reste à payer</h6>
                                                        <h3 className="text-dark mb-0">
                                                            {Math.max(0, order.resteapayer - calculateSelectedDiscountTotal()).toFixed(2)} €
                                                        </h3>
                                                    </div>
                                                </div>
                                                <div className="text-end">
                                                    <small className="text-muted d-block">Économie</small>
                                                    <span className="badge bg-success fs-6">
                                                        {calculateSelectedDiscountTotal().toFixed(2)} €
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {selectedDiscounts.length > 0 && (
                                    <div className="d-flex justify-content-between align-items-center border-top pt-3">
                                        <div className="d-flex align-items-center">
                                            <div className="me-3">
                                                <span className="badge bg-primary rounded-pill p-2">
                                                    {selectedDiscounts.length} avoir{selectedDiscounts.length > 1 ? 's' : ''}
                                                </span>
                                            </div>
                                            <div>
                                                <small className="text-muted d-block">Total sélectionné</small>
                                                <h5 className="text-primary mb-0">{calculateSelectedDiscountTotal().toFixed(2)} €</h5>
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <Button
                                                color="light"
                                                className="me-2 d-flex align-items-center"
                                                onClick={() => setSelectedDiscounts([])}
                                                disabled={isApplyingDiscounts}
                                            >
                                                <i className="ri-close-circle-line me-1"></i>
                                                Tout désélectionner
                                            </Button>
                                            <Button
                                                color="success"
                                                className="d-flex align-items-center px-4"
                                                onClick={handleApplyDiscounts}
                                                disabled={isApplyingDiscounts}
                                            >
                                                {isApplyingDiscounts ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                        Application en cours...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="ri-check-line me-2"></i>
                                                        Appliquer les avoirs
                                                    </>
                                                )}
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <div className="text-center py-5">
                                <i className="ri-coupon-line display-1 text-muted mb-3"></i>
                                <h5 className="text-muted">Aucun avoir disponible</h5>
                                <p className="text-muted mb-0">Ce client n'a pas d'avoir à utiliser.</p>
                            </div>
                        )}
                    </ModalBody>
                </Modal>
                <Modal isOpen={modalOpen} toggle={handleModalClose}>
                    <ModalHeader toggle={handleModalClose}>
                        {selectedPayment === "Cheque" ? "Détails du Chèque" :
                            selectedPayment === "Virement" ? "Détails du Virement" :
                                "Détails de Transaction"}
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="transactionId">
                                {selectedPayment === "Cheque" ? "Numéro du Chèque" :
                                    selectedPayment === "Virement" ? "Numéro de Transaction" :
                                        "Numéro de Transaction"}
                            </Label>
                            <Input
                                type="text"
                                name="transactionId"
                                id="transactionId"
                                value={paymentDetails.transactionId}
                                onChange={handlePaymentDetailsChange}
                                placeholder={
                                    selectedPayment === "Cheque" ? "Entrez le numéro du chèque" :
                                        selectedPayment === "Virement" ? "Entrez le numéro de transaction" :
                                            "Entrez le numéro de transaction"
                                }
                            />
                        </FormGroup>
                        {selectedPayment === "Cheque" && (
                            <FormGroup>
                                <Label for="bank">Banque</Label>
                                <Input
                                    type="text"
                                    name="bank"
                                    id="bank"
                                    value={paymentDetails.bank}
                                    onChange={handlePaymentDetailsChange}
                                    placeholder="Entrez le nom de la banque"
                                />
                            </FormGroup>
                        )}
                        <Button
                            color="success"
                            size="lg"
                            className="w-100"
                            onClick={handlePayment}
                            disabled={
                                !isPaymentEnabled
                            }
                        >
                            Payer
                        </Button>
                    </ModalBody>
                </Modal>
                <Modal
                    isOpen={pdfModalOpen}
                    toggle={togglePdfModal}
                    centered
                    size="xl"
                    className="modal-fullscreen-sm-down"
                    style={{ maxWidth: '90vw', maxHeight: '90vh' }}
                >
                    <ModalBody className="p-0" style={{ height: '85vh' }}>
                        <iframe
                            src={order?.invoicepdf || order?.resultPDF || ""}
                            title={order?.type === "facture" ? "Facture PDF" : "Commande PDF"}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                        />
                    </ModalBody>
                </Modal>
                <div style={{ position: 'fixed', bottom: '10px', right: '10px', zIndex: 1050 }}>
                    <Toast isOpen={showToast} className="bg-success text-white">
                        <ToastHeader
                            className="bg-success text-white"
                            toggle={() => setShowToast(false)}
                        >
                            Succès
                        </ToastHeader>
                        <ToastBody>Paiement effectué avec succès!</ToastBody>
                    </Toast>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Caisse;

function convertPaymentType(type_paiement: any): React.ReactNode | Iterable<React.ReactNode> {
    switch (type_paiement) {
        case "CB":
            return "Carte bancaire";
        case "CHQ":
            return "Chèque";
        case "LIQ":
            return "Espèces";
        case "VIR":
            return "Virement";
        default:
            return "Avoir";
    }
}